import ModuleConfig from './Config';
const actions = ModuleConfig.Actions;

const initialState = {
    data: [],
    count: 0,
    page: 1,
    pageCount: 1,
    pageSize: 20,
    search: "",
    searchColumn: "",
    sortDirection: "",
    cardGames: [],
    current: {},
    errors: {}
}

export default function cards(state = initialState, action) {
    switch(action.type) {
        case actions.getCardGames.success.id:
            return Object.assign({}, state, {
                cardGames: action.options.data
            })
        case actions.getAll.success.id:
            return Object.assign({}, state, {
                data: action.options.data,
                count: action.options.count,
                pageSize: action.options.pageSize,
                page: action.options.page,
                pageCount: action.options.pageCount,
                search: action.options.search,
                sortColumn: action.options.sortColumn,
                sortDirection: action.options.sortDirection
            })
        case actions.getOne.success.id:
        case actions.edit.success.id:
            return Object.assign({}, state, {
                current: action.options,
                errors: {}
            })
        case actions.edit.failure.id:
        case actions.create.failure.id:
            return Object.assign({}, state, {
                errors: action.options
            })
        case actions.delete.success.id:
            return Object.assign({}, state, {
                current: {},
                errors: {}
            })
        default:
            return state;
    }
}
